import { useAtom, useSetAtom } from 'jotai';
import type { RootStateOrAny } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { usePreferences } from '../../react-query/usePreferences';
import routesConstants from '../../routes/routes.constants';
import { directorPracticeIdAtom } from '../../utils/hooks/useDirectorPracticeView';
import {
  operatoryFilterAtom,
  selectedCountsFilterAtom,
  selectedProvidersAtom,
} from '../patientList/atoms';

interface PracticeCardProps {
  practice: any;
  title?: 'huddle' | 'claims';
  onClose?: () => void;
}

export const PracticeCard = ({
  practice,
  title,
  onClose,
}: PracticeCardProps) => {
  const [, setDirectorPracticeId] = useAtom(directorPracticeIdAtom);
  const setSelectedOperatories = useSetAtom(operatoryFilterAtom);
  const setSelectedProviders = useSetAtom(selectedProvidersAtom);
  const setSelectedCountsFilter = useSetAtom(selectedCountsFilterAtom);
  const user = useSelector((state: RootStateOrAny) => state?.login?.user);
  const { data: prefs } = usePreferences();

  const history = useHistory();

  const isClaimsOnly = prefs?.standaloneClaimsEnabled;

  const handlePracticeClick = (practiceId: string) => {
    if (practiceId === `organization-${user?.primaryOrganizationId}`) {
      setDirectorPracticeId(null);
      history.push(`${routesConstants.SWITCHBOARD}`);
    } else {
      setDirectorPracticeId(practiceId);
      const targetRoute =
        isClaimsOnly || title === 'claims'
          ? routesConstants.CLAIMS
          : routesConstants.UPLOADER;

      history.push(`${targetRoute}?director_view_practice_id=${practiceId}`);
    }
    setSelectedOperatories([]);
    setSelectedProviders([]);
    setSelectedCountsFilter(undefined);
    onClose?.();
  };
  return (
    <Link
      className="vai-w-[144px] vai-min-h-[72px] vai-flex vai-items-center vai-justify-center vai-p-y-4 vai-p-x-2 vai-gap-4 vai-border-2 vai-border-solid vai-border-gray-200 vai-rounded-md vai-bg-white"
      data-cy={`practice-${practice.name}`}
      data-testid={`practice-${practice.name}`}
      to={
        isClaimsOnly || title === 'claims'
          ? `${routesConstants.CLAIMS}?director_view_practice_id=${practice.id}`
          : `${routesConstants.UPLOADER}?director_view_practice_id=${practice.id}`
      }
      onClick={() => {
        handlePracticeClick(practice.id);
      }}
    >
      <div className="vai-w-[128px] vai-min-h-[40px] vai-flex vai-items-center vai-justify-center vai-text-sm vai-text-center vai-font-medium vai-text-gray-800 practice-name">
        {practice.name}
      </div>
    </Link>
  );
};
